// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"328":"wrapup","342":"plan","522":"Debugger","663":"credits","664":"maengel"}[chunkId] || chunkId) + "-legacy." + {"22":"125c2fe4","328":"9d95e4bd","342":"c4c480bb","522":"0c7bd08d","652":"a7816e3a","663":"47b5a99f","664":"5c254a4b","745":"e682e180"}[chunkId] + ".js";
};